module.exports = __webpack_public_path__ + "img/af35dd622fd73dbae39ae689d38f75ea.png";